import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef, useState } from "react";
import ExpenseReportFormConfig from "./form";
import { Button, Col, Row } from "reactstrap";
import { getYearBoundaries } from "@utils/Utils";
import { ExpenseReportFormDataType } from "@/formTypes/ExpenseReportFormDataType";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type ExpenseYearReportFormProps = {
}

const ExpenseYearReportForm = forwardRef<DynamicFormRef, ExpenseYearReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      formRef.current?.resetFormValue({
        year
      })
    }, [])

    const getFormConfig = () => {
      return ExpenseReportFormConfig;
    }

    const generateForm = (formData: ExpenseReportFormDataType) => {
      const { startDate, endDate } = getYearBoundaries(`${formData.year}`, true)
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/expenseByMonth/${startDate}/${endDate}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        window.open(`/user/reports/excel/expenseByMonth/${startDate}/${endDate}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<ExpenseReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default ExpenseYearReportForm;